import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 初始化状态
  },
  mutations: {
    // 同步修改状态的方法
  },
  actions: {
    // 异步操作
  },
  modules: {
    // 子模块
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js